import React, { useState } from "react";
import { Card, Divider } from "antd";

const PurchaseItems = ({ onSelectItem }) => {
  const [selectedCard, setSelectedCard] = useState(null);

  const items = [
    { id: 1, price: "$5", currency: "AUD", points: 5 },
    { id: 2, price: "$25", currency: "AUD", points: 25 },
    { id: 3, price: "$50", currency: "AUD", points: 50, popular: true },
    { id: 4, price: "$100", currency: "AUD", points: 100 },
    { id: 5, price: "$250", currency: "AUD", points: 250 },
    { id: 6, price: "$500", currency: "AUD", points: 500 },
    { id: 7, price: "$1000", currency: "AUD", points: 1000 },
  ];

  const handleSelect = (item) => {
    setSelectedCard(item.id);
    onSelectItem(item);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 m-1">
      {items.map((item) => (
        <Card
          key={item.id}
          onClick={() => handleSelect(item)}
          className={`flex flex-col rounded-xl cursor-pointer hover:shadow-lg dark-mode-card
            ${
              item.popular
                ? "border-2 border-emerald-500 bg-gradient-to-br from-emerald-50 to-white dark:from-emerald-900 dark:to-white/5" + 
                  (selectedCard === item.id ? "ring-2 ring-emerald-500" : "")
                : "border-2 border-slate-200 " + 
                  (selectedCard === item.id ? "ring-2 ring-emerald-500" : "")
            }`}

        >
          {item.popular && (
            <span className="rounded-lg border px-2 py-0.5 text-xs font-medium bg-gradient-to-r from-emerald-500 to-purple-500 text-white ">
              Most Popular
            </span>
          )}

          <div className="space-y-4">
            <div>
              <p className="text-[14px] mb-1 title-text">
                Price
              </p>
              <div className="flex items-baseline gap-1">
                <span className="text-[32px] font-semibold text-emerald-600 dark:text-emerald-500">
                  {item.price}
                </span>
                <span className="text-[14px] muted-text">
                  {item.currency}
                </span>
              </div>
            </div>

            <Divider className="my-4 dark:bg-white" />

            <div>
              <div className="flex items-center justify-between">
                <span className="text-[14px] font-semibold title-text">
                  Points Received
                </span>
                <span className="inline-flex items-center justify-center rounded-lg border font-medium w-fit whitespace-nowrap shrink-0 bg-gradient-to-r from-emerald-500 to-purple-500 text-white text-[14px] px-3 py-1">
                  {item.points} Points
                </span>
              </div>
              <p className="text-[12px] mt-2 text-center muted-text">
                1:1 Conversion Rate
              </p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default PurchaseItems;
